import { render, staticRenderFns } from "./DetailFormModal.vue?vue&type=template&id=d8c06b16&scoped=true&"
import script from "./DetailFormModal.vue?vue&type=script&lang=js&"
export * from "./DetailFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8c06b16",
  null
  
)

export default component.exports